const LOCATION_KEY = 'locations';
const LOCATION_VER_KEY = 'locations_version';

function parse(json, fallback) {
  try { return JSON.parse(json); } catch { return fallback; }
}

function setAll(list) { localStorage.setItem(LOCATION_KEY, JSON.stringify(list || [])); }
function setVersion(v) { localStorage.setItem(LOCATION_VER_KEY, v || ''); }
function save(version, list) { setVersion(version); setAll(list); }

function getAll() { return parse(localStorage.getItem(LOCATION_KEY), []); }
function getVersion() { return localStorage.getItem(LOCATION_VER_KEY); }

function getByLevel(level) {
  if (level == null || level === '') return [];
  const lv = String(level).trim().toLowerCase();
  return getAll().filter(b => String(b?.level ?? '').trim().toLowerCase() === lv);
}

function getByCity(city, opts = {}) {
  const by = opts.by || 'city';
  if (!city) return [];
  const target = String(city).trim().toLowerCase();
  return getAll().filter(b => String(b?.[by] ?? '').trim().toLowerCase() === target);
}

function getByCityLevel(city, level, opts = {}) {
  const by = opts.by || 'city'; 
  if (!city) return [];
  const s = String(city).trim().toLowerCase();
  const lv = level == null ? '' : String(level).trim().toLowerCase();

  return getAll().filter(b => {
    const matchS = String(b?.[by] ?? '').trim().toLowerCase() === s;
    if (!matchS) return false;
    if (!lv) return true;
    return String(b?.level ?? '').trim().toLowerCase() === lv;
  });
}

function clear() {
  localStorage.removeItem(LOCATION_KEY);
  localStorage.removeItem(LOCATION_VER_KEY);
}

export default {
  save, setAll, setVersion, getAll, getVersion, getByLevel, getByCity, getByCityLevel, clear
};